export default "__VITE_ASSET__BT4CE0rH__"